import { VLP_PATH } from "@common/helpers/isVehicleListingPage";
import translate from "@common/helpers/translate";
import { setBodyStyleIcon } from "@modules/vehicle/components/VehicleBodyStylesFilter";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import { useRouter } from "next/router";
import Button from "@components/Button";
import cleanVlpQueryParam from "@modules/vehicle/helpers/cleanVlpQueryParam";
import { VehicleBodyStyle } from "@modules/vehicle/types/Vehicle";

type Props = {
  bodyStyles: VehicleBodyStyle[] | undefined;
};

interface Orderable {
  order: number;
}

const ShopByBodyStyle = ({ bodyStyles }: Props) => {
  const { t } = useTranslation(["common"]);
  const { locale } = useRouter();
  const iconClassName = "block m-auto text-primary-bold w-24 h-12 xl:w-20";

  const orderFunction = (a: Orderable, b: Orderable) => a.order - b.order;

  return (
    <div>
      <p className="body-1 pb-4">{t("common:shop_by_body_style")}</p>
      <ul className="body-3 grid grid-cols-2 md:grid-cols-3 xl:grid-cols-8 gap-2">
        {bodyStyles &&
          bodyStyles.sort(orderFunction).map((bds) => (
            <li key={bds.id}>
              <Link
                href={`/${VLP_PATH}/${cleanVlpQueryParam(
                  translate(bds.name, locale || "")
                )}`}
              >
                <Button
                  buttonStyle="filter"
                  fill="outline"
                  spacing="tight-hug"
                  className="rounded-[4px] active:bg-gray-25"
                >
                  <div className="py-1">
                    {setBodyStyleIcon(bds.id, iconClassName)}
                    {translate(bds.name, locale || "")}
                  </div>
                </Button>
              </Link>
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ShopByBodyStyle;
